import {
  GET_API_CREDENTIAL_REQUEST,
  GET_API_CREDENTIAL_SUCCESS,
  GET_API_CREDENTIAL_FAILED,
} from '../types';

import { combineReducers } from 'redux';

const IntialState = {
  loading: false,
  status: null,
  message: null,
  isSaved: false,
  isError: false,
};

const APICredentials = (state = IntialState, action) => {
  const { type, response, message } = action;
  switch (type) {
    case GET_API_CREDENTIAL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_API_CREDENTIAL_SUCCESS:
      return {
        ...state,
        status: response.status,
        isSaved: response.isSaved,
        loading: false,
        isError: false,
      };
    case GET_API_CREDENTIAL_FAILED:
      return {
        ...state,
        message,
        loading: false,
        isError: true,
      };
    default:
      return state;
  }
};

const credentials = combineReducers({
  APICredentials,
});
export default credentials;
